import fdbackIntroJson from '@/mock/fdbackintro.js'

export const helpFdbackData = (params, cb, error) => {
    cb(fdbackIntroJson)
}




// WEBPACK FOOTER //
// ./src/api/fdback.js